// Cliente único do Supabase para o site. Só a chave publicável.
import { createClient } from "@supabase/supabase-js";
import { config } from "./config";

const cfg = config();

export const supabase = createClient(cfg.supabaseUrl, cfg.supabasePublishableKey);

/**
 * Cliente descartável, sem sessão guardada: serve para conferir a senha atual
 * (signInWithPassword) sem trocar nem rebaixar a sessão aal2 do cliente principal.
 */
export function isolatedClient() {
  return createClient(cfg.supabaseUrl, cfg.supabasePublishableKey, {
    auth: { persistSession: false, autoRefreshToken: false, detectSessionInUrl: false },
  });
}
